import React from "react";
import ReactDOM from "react-dom";
import MassEditReact from "./MassEdit";

export class MassEdit extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.innerHTML = `<div id="root"></div>`;

    ReactDOM.render(
      React.createElement(MassEditReact, { groupId: this.getAttribute("group_id") }),
      this.querySelector("#root")
    );
  }
}
customElements.define('mass-edit', MassEdit);
